module.exports = __webpack_public_path__ + "static/media/img_howto_image@2x.f91bf74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_howto_image@2x.png
// module id = 1083
// module chunks = 0